/**
 * Normalize storefront payload (supports legacy `themeColor` as primary).
 * @param {Record<string, unknown> | undefined} raw
 */
export function normalizeStorefront(raw) {
  const s = raw && typeof raw === 'object' ? raw : {}
  return {
    storeName: typeof s.storeName === 'string' ? s.storeName : '',
    subdomain: typeof s.subdomain === 'string' ? s.subdomain : '',
    logoUrl:
      typeof s.logoUrl === 'string'
        ? s.logoUrl
        : 'https://placehold.co/120x40/e2e8f0/64748b?text=Logo',
    themePrimary:
      typeof s.themePrimary === 'string'
        ? s.themePrimary
        : typeof s.themeColor === 'string'
          ? s.themeColor
          : '#3b82f6',
    themeSecondary: typeof s.themeSecondary === 'string' ? s.themeSecondary : '#64748b',
    contactEmail: typeof s.contactEmail === 'string' ? s.contactEmail : '',
    contactPhone: typeof s.contactPhone === 'string' ? s.contactPhone : '',
    sellingSummary: typeof s.sellingSummary === 'string' ? s.sellingSummary : '',
    tagline: typeof s.tagline === 'string' ? s.tagline : '',
    aboutText: typeof s.aboutText === 'string' ? s.aboutText : '',
  }
}
